import { Icon, IconProps } from "@chakra-ui/react"

const ReviewIcon = (props: IconProps) => (
  <Icon
    xmlns='http://www.w3.org/2000/svg'
    width='26px'
    height='26px'
    viewBox='0 0 26 26'
    fill='none'
    {...props}
  >
    <path
      d='M8.38336 14.0517L11.6782 12.0523L14.973 14.0517L14.1 10.3063L17.0288 7.77184L13.1707 7.46206L11.6782 3.91379L10.1857 7.46206L6.32761 7.77184L9.25635 10.3063L8.38336 14.0517ZM0.413818 22.7816V0.252869H22.9426V18.2759H4.91957L0.413818 22.7816ZM3.96209 16.023H20.6897V2.50574H2.66669V17.2902L3.96209 16.023Z'
      fill='white'
    />
  </Icon>
)

export default ReviewIcon
